





















import BaseField from '@/views/Company/Settings/Narrowcasting/Collections/BaseField.vue'
import { Component } from 'vue-property-decorator'

@Component
export default class ConstructionTypeField extends BaseField {
    get fieldName(): string {
        return 'construction_type'
    }

    get options(): Array<{ label: string, value: string }> {
        return this.filterConfig.values.map(entry => ({
            label: this.$t(`narrowcasting.filters.values.${this.fieldName}.${entry}`).toString(),
            value: entry,
        }))
    }
}
